#import "../../LookupCorporateAccountFields.graphql"
mutation LookupCorporateAccountCreate(
  $input: LookupCorporateAccountCreateInput!
) {
  lookupCorporateAccountCreate(input: $input) {
    lookupCorporateAccount {
      ...LookupCorporateAccountFields
    }
  }
}
